import { Action } from '@shared/interfaces/actions';
import { ActionDto } from '@shared/interfaces/dtos/actions';
import { ScheduleUtil } from './schedule.util';
import { ActionScope, ActionType } from '@shared/types/actions';
import { PointLinkedMeetingDto } from '@shared/interfaces/dtos/points';

export abstract class ActionsMapper {
  private static determineActionRecipientKind(action: ActionDto): 'user' | 'service' | 'group' {
    const { action: detail } = action;

    if (detail.contactId || detail.contactIdiAdmin) {
      return 'user';
    } else if (detail.serviceId) {
      return 'service';
    } else if (detail.groupeId) {
      return 'group';
    }

    return 'user';
  }

  public static toAction(action: ActionDto, scope: ActionScope, type: ActionType): Action {
    return {
      scope,
      type,
      id: action.action.id,
      pointId: action.pointId,
      meetingId: action.seanceId,
      demander: {
        id: action.action.transmissionUserId,
        fromIadmin: true,
        kind: 'user',
      },
      recipient: {
        id:
          ActionsMapper.determineActionRecipientKind(action) === 'user'
            ? action.action.contactIdiAdmin
            : ActionsMapper.determineActionRecipientKind(action) === 'service'
              ? action.action.serviceId
              : action.action.groupeId,
        fromIadmin: ActionsMapper.determineActionRecipientKind(action) === 'user',
        kind: ActionsMapper.determineActionRecipientKind(action),
      },
      mailId: action.mailId,
      meeting: action.seanceLink ?? ({ description: action.objet, id: action.seanceId } as PointLinkedMeetingDto),
      purpose: action.action.action,
      status: action.action.statut ?? null,
      deadline: action.action.echeance ? new Date(action.action.echeance) : null,
      message: action.action.message,
      subject: action.objet,
      serviceId: action.action.serviceId,
      groupId: action.action.groupeId,
      answer: action.action.reponse,
      done: !!action.action.traiteLe,
      doneAt: action.action.traiteLe ? new Date(action.action.traiteLe) : null,
      createdAt: new Date(action.action.transmisDate),
      delayedAnnouncement: ScheduleUtil.delaySinceToday(new Date(action.action.transmisDate)),
      processable: action.action.rights.canReply,
    };
  }
}
